jQuery(function ($) {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
      navigator.userAgent
    )
  ) {
    $("#not-mobile-device").hide();
    $("#mobile-device").show();
    $("#open-video-pop-up").click(function () {
      $("#video-pop-up").show();
    });
    $("#video-pop-up .icon-close").click(function () {
      $("#accueil-video-mobile").trigger('pause');
      $("#video-pop-up").hide();
    });
  }
});
